import { Point } from "highcharts";
import moment from "moment/moment";
import {
  dateFromUtcByTimeZone,
  formatDate,
} from "@/utils/helpers/date-time/datetime-format";
import { getTooltipOptions } from "@/storybook/c8r-highcharts/common/utils/tooltip/getTooltipOptions";

const tooltipMarkupGenerator = (point: Point) => {
  const index = point.x ?? 0;

  const timestamp = formatDate(
    dateFromUtcByTimeZone(`${point.category}`) || moment(),
    { type: "dateTime" },
  );

  const dataItems = point.series.chart.series;

  const chartItems = dataItems.toReversed().map((item) => {
    const options = item.userOptions as any;

    return {
      name: item.name
        .replace("(Recommended)", "")
        .replace("(Current)", "")
        .replace("%", ""),
      value: options?.data?.[index],
      color: options?.color || "#000000",
      type: item.name.includes("Current") ? "current" : "recommended",
    };
  });

  return `
       <div style="font-size: 10px; font-family: sans-serif;">
        <div style="margin-bottom: 4px;">
          ${timestamp}
        </div>

        ${chartItems
          .map((item) => {
            return `
            <div style="margin-bottom: 4px;">
             ${item.name} ${item.value.toFixed(2)}%
                  
             <span style="font-weight: bold; color: ${item.color}; margin-left: 4px;">
              ${item.type === "recommended" ? "(Recommended)" : "(Current)"}
             </span>
            </div>`;
          })
          .join("")}
      </div>
    `;
};

export const rightsizingChartTooltipOptions = getTooltipOptions({
  tooltipMarkupGenerator,
  tooltipOptions: {
    shared: true,
  },
});
